import React, { useState, useEffect } from "react";
import { Building2, MapPin, ArrowUpRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ThreeDots } from "react-loader-spinner";
import { getJobPosts } from '@/lib/jobHelpers';

const JobListings = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJobs = async () => {
      setLoading(true);
      try {
        const result = await getJobPosts();
        if (result.success) {
          setJobs(result.jobs);
        } else {
          setError('Failed to fetch jobs');
        }
      } catch (error) {
        console.error('Error:', error);
        setError('Failed to fetch jobs');
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <ThreeDots height="50" width="50" color="#3b82f6" ariaLabel="loading" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-red-500 py-8">
        {error}
      </div>
    );
  }

  return (
    <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-6 dark:text-white">
        Latest Job Opportunities
      </h2>

      <div className="grid gap-4 sm:gap-6">
        {jobs.map((job) => (
          <Card
            key={job.id}
            className="p-4 sm:p-6 hover:shadow-lg transition-shadow dark:bg-gray-800"
          >
            <div className="flex flex-col sm:flex-row justify-between sm:items-start gap-4">
              <div className="space-y-3 sm:space-y-4 w-full">
                <div>
                  <h3 className="text-lg sm:text-xl font-semibold text-blue-600 dark:text-blue-400">
                    {job.title}
                  </h3>
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-gray-600 dark:text-gray-300 mt-2">
                    <div className="flex items-center">
                      <Building2 className="w-4 h-4 mr-2" />
                      {job.company}
                    </div>
                    <div className="flex items-center">
                      <MapPin className="w-4 h-4 mr-2" />
                      {job.location}
                    </div>
                  </div>
                </div>

                <p className="text-gray-700 dark:text-gray-300">
                  {job.description}
                </p>

                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                  <div className="text-sm text-gray-500 dark:text-gray-400">
                    Posted by {job.postedBy} •{" "}
                    {new Date(job.postedDate).toLocaleDateString()}
                  </div>
                  <Button
                    className="w-full sm:w-auto flex items-center justify-center gap-2"
                    onClick={() => window.open(job.applyLink, "_blank")}
                  >
                    <span>Apply Now</span>
                    <ArrowUpRight className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default JobListings;
